import * as React from 'react';
import { AccordionSection } from '@wix/wix-base-ui/lib/esm';
import type { IWbuAccordionProps } from '../WbuAccordion.props';
import './WbuAccordion.global.scss';
import WbuContainer from '../../WbuContainer/WbuContainer';
import { getDataAttributes } from '../../../common/utils';

const WbuAccordion: React.FC<IWbuAccordionProps> = props => {
  const {
    id,
    className,
    label,
    tooltip,
    openByDefault,
    updateComponentPropsInViewer,
    onChange,
  } = props;

  const _onToggle = (isOpen: boolean) => {
    updateComponentPropsInViewer({ openByDefault: isOpen });
    onChange?.({ type: 'change' } as React.ChangeEvent);
  };

  return (
    <WbuContainer id={id} className={className} {...getDataAttributes(props)}>
      <AccordionSection
        label={label || 'Label Example'}
        infoContent={tooltip}
        isOpen={openByDefault}
        onToggle={_onToggle}
        removeBottomDivider={openByDefault}
      />
    </WbuContainer>
  );
};

export default WbuAccordion;
